import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 65%;
  float: left;
  margin-top: 1rem;
  margin-left: 1rem;
  & .hefesto-link {
    font-weight: 600;
    font-size: large;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.blue4};
  }
`;
